// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1_faA","cls2":"Base-cls2_oBE Base-cls1_faA","expanded":"Base-expanded_ezd","collapsed":"Base-collapsed_h8Q","reply":"Base-reply_AV0","more":"Base-more_Q3v"};